import Fade from "react-reveal/Fade";

export default function SectionFive() {
  const bidangusaha = [
    "SOCIAL",
    "ENVIRONMENT",
    "EDUCATION",
    "HEALTH",
    "INDUSTRI",
    "FOOD & BEVERAGE",
    "FASHION",
    "IT",
    "SERVICES",
    "AUTOMOTIVE",
    "COSMETICS",
    "FINANCE",
  ];

  return (
    <div className="flex flex-col text-white">
      <div className="md:w-4/12 w-8/12 mx-auto">
        <Fade bottom>
          <img
            className="w-full"
            src="/img/imgsec5.jpg"
            alt="section 5 gambar"
          />
        </Fade>
      </div>
      <Fade bottom>
        <h1 className="text-center uppercase md:text-4xl mt-10 text-3xl font-bold">
          Kami juga telah mendesain 100+ logo untuk berbagai bidang usaha,
          yakni:
        </h1>
      </Fade>
      <Fade bottom>
        <ul className="grid md:mx-auto mt-10 md:grid-rows-6 md:grid-flow-col md:w-6/12 list-disc text-2xl font-bold uppercase px-5">
          {bidangusaha.map((bu, i) => (
            <li key={i}>{bu}</li>
          ))}
        </ul>
      </Fade>
    </div>
  );
}
